import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import StorefrontIcon from '@mui/icons-material/Storefront'
import StoreIcon from '@mui/icons-material/Store'
import CoffeeIcon from '@mui/icons-material/Coffee'
import CookieIcon from '@mui/icons-material/Cookie'
import RestaurantIcon from '@mui/icons-material/Restaurant'

import UserLayout from '../../layouts/UserLayout'

const categories = [
	{
		name: 'Nem',
		path: 'stock/fresh',
		// productId: '8',
		bgColor: '#b8e6d9',
		icon: <StorefrontIcon sx={{ fontSize: 30, color: '#00a65a' }} />,
	},
	{
		name: 'Vani',
		path: 'stock/vani',
		productId: '8',
		bgColor: '#d4e9c9',
		icon: <StoreIcon sx={{ fontSize: 30, color: '#4caf50' }} />,
	},
	{
		name: 'Cafe',
		path: 'stock/cafe',
		productId: '9',
		bgColor: '#e0d5d5',
		icon: <CoffeeIcon sx={{ fontSize: 30, color: '#795548' }} />,
	},
	{
		name: 'Bánh Giòn',
		path: 'stock/banh-gion',
		productId: '10',
		bgColor: '#ffe4bc',
		icon: <CookieIcon sx={{ fontSize: 30, color: '#ff9800' }} />,
	},
	{
		name: 'Chả Giò',
		path: 'stock/cha-gio',
		productId: '16',
		bgColor: '#ffcdd2',
		icon: <RestaurantIcon sx={{ fontSize: 30, color: '#f44336' }} />,
	},
]

function StoreManagerOptions() {
	const navigate = useNavigate()

	const CategoryCard = ({ category }) => (
		<Paper
			elevation={3}
			sx={{
				width: 240,
				height: 160,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: category.bgColor,
				cursor: 'pointer',
				transition: 'transform 0.2s',
				'&:hover': {
					transform: 'scale(1.02)',
				},
			}}
			onClick={() =>
				navigate(`/store-manager/${category.path}`, {
					state: { productId: category.productId },
				})
			}>
			<Box
				sx={{
					backgroundColor: 'white',
					borderRadius: '50%',
					p: 1,
					mb: 1,
				}}>
				{category.icon}
			</Box>
			<Typography
				variant='h6'
				sx={{
					color: '#333',
					fontWeight: 'normal',
				}}>
				{category.name}
			</Typography>
		</Paper>
	)

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: '100%',
					margin: '0 auto',
					p: 2,
					display: 'flex',
					flexDirection: 'column',
					gap: 2,
				}}>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						gap: 3,
						flexWrap: 'nowrap',
					}}>
					{categories.map((category) => (
						<CategoryCard key={category.name} category={category} />
					))}
				</Box>
			</Box>
		</UserLayout>
	)
}

export default StoreManagerOptions
